<template>
  <v-row>
    <v-col class="pb-0" cols="12">
      <b-input
        v-model="internalStaffUnit.name"
        :error-messages="getErrorMessages(v$.name)"
        label="Повна назва штатної одиниці"
        placeholder="Введіть назву"
        @blur="v$.name.$touch()" />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="6">
      <b-select
        v-model="internalStaffUnit.departmentId"
        :error-messages="departmentError || getErrorMessages(v$.departmentId)"
        :items="departmentItems"
        :loading="$loading.isLoading('activeInternalDepartments')"
        label="Підрозділ"
        placeholder="Оберіть зі списку"
        @blur="v$.departmentId.$touch()" />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="6">
      <b-select
        v-model="internalStaffUnit.positionId"
        :error-messages="getErrorMessages(v$.positionId)"
        :items="$directory.get('orgPositions')"
        :loading="$loading.isLoading('orgPositions')"
        label="Посада"
        placeholder="Оберіть зі списку"
        @blur="v$.positionId.$touch()" />
    </v-col>
    <v-col class="pt-0" cols="12" md="6">
      <b-select
        v-model="internalStaffUnit.staffUnitTypeId"
        :error-messages="getErrorMessages(v$.staffUnitTypeId)"
        :items="$directory.get('orgStaffUnitTypes')"
        :loading="$loading.isLoading('orgStaffUnitTypes')"
        label="Тип штатної одиниці"
        placeholder="Оберіть зі списку"
        @blur="v$.staffUnitTypeId.$touch()" />
    </v-col>
  </v-row>
</template>
<script lang="ts">
import { computed, reactive } from 'vue'
import { required, useVuelidate } from '@/plugins'
import { getErrorMessages } from '@/utils/helpers'
import { setSnackbar } from 'best-modules/plugins'
import { fillDirectory, getDirectory } from '@/directory/index.ts'
import { InternalStaffUnitCredentials } from '@/utils/types/internalStaffUnit'
import {
  internalStaffUnitCreate,
  internalStaffUnitUpdate,
} from '@/requests/internalStaffUnit'

export default {
  name: 'InternalStaffUnitDialog',
  props: {
    dialog: { type: Object, required: true },
  },
  methods: { getErrorMessages },
  async setup(props) {
    await fillDirectory([
      'activeInternalDepartments',
      'orgPositions',
      'orgStaffUnitTypes',
    ])

    const isUpdate = props.dialog.action === 'update'
    const itemData = props.dialog.dialogData?.itemData

    const internalStaffUnit = reactive<InternalStaffUnitCredentials>({
      name: itemData?.name ?? '',
      departmentId: itemData?.departmentId ?? null,
      positionId: itemData?.positionId ?? null,
      staffUnitTypeId: itemData?.staffUnitTypeId ?? null,
    })

    const currentDepartment = itemData?.department || null
    const isCurrentDepartmentInactive =
      currentDepartment && !currentDepartment.isActive

    const departmentItems = computed(() => {
      const activeList = getDirectory('activeInternalDepartments') || []
      if (isCurrentDepartmentInactive) {
        const inactiveItem = {
          id: currentDepartment.id,
          name: `${currentDepartment.name} (деактивований)`,
        }
        return [inactiveItem, ...activeList]
      }
      return activeList
    })

    const departmentError = computed(() => {
      if (
        isCurrentDepartmentInactive &&
        internalStaffUnit.departmentId === currentDepartment.id
      ) {
        return 'Підрозділ деактивовано. Оберіть інший активний підрозділ.'
      }
      return null
    })

    const v$ = useVuelidate(
      {
        name: { required },
        departmentId: { required },
        positionId: { required },
        staffUnitTypeId: { required },
      },
      internalStaffUnit
    )

    const submit = () => {
      const request = isUpdate
        ? internalStaffUnitUpdate(itemData.id, internalStaffUnit)
        : internalStaffUnitCreate(internalStaffUnit)

      return request.then(res => {
        setSnackbar({
          text: `Штатну одиницю ${isUpdate ? 'оновлено' : 'створено'}`,
        })
        return res
      })
    }

    return {
      internalStaffUnit,
      v$,
      submit,
      departmentItems,
      departmentError,
      validationScope: 'internalStaffUnit',
    }
  },
}
</script>
